"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerSchema = exports.register = void 0;
const react_1 = require("react");
const helpers_1 = require("../helpers");
const handlers_1 = require("../handlers");
const defaultOptions = {
    validateOnBlur: true,
    validateOnChange: true,
};
const register = (name, context, options) => {
    const ref = (0, react_1.useRef)();
    const contextField = context.fields?.[name];
    const contextSchema = context.schema?.[name];
    const fieldOptions = {
        ...defaultOptions,
        ...contextSchema,
        ...options,
    };
    const defaultEvent = () => {
        const { value } = (0, helpers_1.getPropsFromRef)(ref);
        (0, handlers_1.handleMethods)({
            value,
            name,
            context,
            options: contextField.options || fieldOptions,
        });
        context.actions?.setFieldValue(name, value);
    };
    const defaultOnChange = () => {
        if (context.errors[name]) {
            context.actions?.clearError(name);
        }
    };
    const field = {
        ref,
        name,
        data: '',
        onBlur: undefined,
        onChange: undefined,
        options: fieldOptions,
    };
    field.onBlur = (...params) => {
        if (fieldOptions.validateOnBlur) {
            defaultEvent();
        }
        fieldOptions?.onBlur && fieldOptions.onBlur(...params);
    };
    field.onChange = (...params) => {
        if (fieldOptions.validateOnChange) {
            defaultEvent();
        }
        else {
            defaultOnChange();
        }
        fieldOptions?.onChange && fieldOptions.onChange(...params);
    };
    context.actions?.setField(name, field);
    return {
        ref,
        name,
        onBlur: field.onBlur,
        onChange: field.onChange,
    };
};
exports.register = register;
const registerSchema = (schema, context) => {
    const fields = {};
    Object.entries(schema).forEach(([name, options]) => {
        fields[name] = register(name, context, options);
        context.actions?.setSchemaField(name, options);
    });
    return fields;
};
exports.registerSchema = registerSchema;
